import { useMemo, useState, useCallback } from "react";
import ImageLightbox from "./ImageLightbox";

export default function GalleryGrid({ items = [] }) {
  const images = useMemo(
    () => items.map((it) => (typeof it === "string" ? { src: it, alt: "" } : it)),
    [items]
  );

  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i) => { setIndex(i); setIsOpen(true); };
  const onClose = useCallback(() => setIsOpen(false), []);
  const onPrev = useCallback(() => setIndex((i) => (i - 1 + images.length) % images.length), [images.length]);
  const onNext = useCallback(() => setIndex((i) => (i + 1) % images.length), [images.length]);

  return (
    <>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
        {images.map((img, i) => (
          <button
            key={i}
            type="button"
            onClick={() => openAt(i)}
            className="group relative aspect-[3/4] bg-gray-100 rounded-xl overflow-hidden focus:outline-none focus:ring-2 focus:ring-black/30"
          >
            <img
              src={img.src}
              alt={img.alt || ""}
              className="w-full h-full object-cover group-hover:scale-[1.02] transition-transform"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition" />
          </button>
        ))}
      </div>

      <ImageLightbox
        images={images}
        index={index}
        isOpen={isOpen}
        onClose={onClose}
        onPrev={onPrev}
        onNext={onNext}
      />
    </>
  );
}
